import fetch from "../utils/fetch";

const baseUrl = process.env.REACT_APP_DATA_API_URL + "/api";

// 人类遗传列表
export function getHumanList(data) {
  return fetch({
    url: baseUrl + "/humanGenetics/SelectHumanGenetics",
    method: "get",
    params: data,
  });
}


// 获取数据类别
export function getDataType(data) {
  return fetch({
    url: baseUrl + "/CatalogueOfRegulations/SelectTableType",
    method: "get",
    params: data,
  });
}
// 法规汇编类目
export function getAssemblyList(data) {
  return fetch({
    url: baseUrl + "/CatalogueOfRegulations/SelectCatalogueOfRegulationsInfo",
    method: "get",
    params: data,
  });
}
// 评审专家
export function getReviewExportList(data) {
  return fetch({
    url: baseUrl + "/ReviewExpert/SelectReviewExpertInfo",
    method: "get",
    params: data,
  });
}
// 厂商标签
export function getCompanyList(data) {
  return fetch({
    url:
    baseUrl + "/ManufacturerRelatedWords/GetManufacturerInfo",
    method: "get",
    params: data,
  });
}
// cma列表
export function getCmaList(data) {
  return fetch({
    url:
      baseUrl + "/CMA/SelectInfo",
    method: "get",
    params: data,
  });
}
// 评审问题汇总列表
export function getAccessProblemList(data) {
  return fetch({
    url:
      baseUrl + "/AssessProblem/SelectAssessProblemInfo",
    method: "get",
    params: data,
  });
}
// 实用链接
export function getPracticalLinkList(data) {
  return fetch({
    url: baseUrl + "/UtilityLinksInfo/SelectInfo",
    method: "get",
    params: data,
  });
}
// 评审专家领域数据
export function getFieldList(data) {
  return fetch({
    url: baseUrl + "/ReviewExpert/SelectAllFieldName", 
    method: "get",
    params: data,
  });
}

// 批件发布列表
export function getPublishList(data) {
  return fetch({
    url: baseUrl + "/approved_document/selectApprovalFileAnnounceInfo",
    method: "get",
    params: data,
  });
}
// 获取公司名称
export function getCompanyName(data) {
  return fetch({
    url: baseUrl + "/company/selectCompanyInfo",
    method: "get",
    params: data,
  });
}
// 获取字典
export function getDictList(data) {
  return fetch({
    url: baseUrl + "/dictionaryDetail/selectDictWeb",
    method: "get",
    params: data,
  });
}


// 获取培训列表
export function getTrainList(data) {
  return fetch({
    url: baseUrl + "/TrainingMeeting/SelectTrainingMeetingInfo",
    method: "get",
    params: data,
  });
}

// 获取来源机构信息 
export function getTrainSourceOrgList(data) {
  return fetch({
    url: baseUrl + "/TrainingMeeting/GetSourceOrganizationInfo",
    method: "get",
    params: data,
  });
}

// 飞行检查 
export function getFlyCheckList(data) {
  return fetch({
    url:  baseUrl + "/problem/SelectInfo",
    method: "get",
    params: data,
  });
}
// 处罚文书 
export function getPunishDocList(data) {
  return fetch({
    url:  baseUrl + "/punishment/SelectInfo",
    method: "get",
    params: data,
  });
}
// 现场检查 
export function getSceneCheckList(data) {
  return fetch({
    url: baseUrl + "/CenterQA/SelectInfo", 
    method: "get",
    params: data,
  });
}

// 分类界定
export function getClassifyData(data) {
  return fetch({
    url: baseUrl + "/ClassificationCefinition/SelectInfo",
    method: "get",
    params: data,
  });
}